import {
    FETCH_DIAGNOSTICOS_REQUEST,
    FETCH_DIAGNOSTICOS_SUCCESS,
    FETCH_DIAGNOSTICOS_FAILURE,
    ADD_DIAGNOSTICO,
    MARK_DIAGNOSTICO_PLANIFICADO
} from "./diagnosticosTypes";

const initialState = {
    items: [],
    loading: false,
    error: null
};

export const diagnosticosReducers = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_DIAGNOSTICOS_REQUEST:
            return { ...state, loading: true };
        case FETCH_DIAGNOSTICOS_SUCCESS:
            return { ...state, loading: false, items: action.payload };
        case FETCH_DIAGNOSTICOS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case ADD_DIAGNOSTICO:
            return { ...state, items: [...state.items, action.payload] };
        case MARK_DIAGNOSTICO_PLANIFICADO:
            return {
                ...state,
                items: state.items.filter(item => item.id !== action.payload)
            };
        default:
            return state;
    }
};
